import * as DelayActionSubTypes from 'automation-ui-action-features/actions/delay/constants/DelayActionSubTypes';
export function inferDelayActionSubType(metadata) {
  const timeDelay = metadata.delay;
  if (timeDelay && timeDelay.daysOfWeek.size > 0) {
    return DelayActionSubTypes.DAY;
  } else if (timeDelay && timeDelay.timeOfDay !== null) {
    return DelayActionSubTypes.TIME;
  } else {
    return DelayActionSubTypes.DURATION;
  }
}